const messages: Record<string, string> = {
	'loader.loading': 'A carregar…',
	'loader.error': 'Não foi possível carregar a página. Tente novamente mais tarde.',
	'connectionError.description': 'Erro de conexão. Por favor, carregue novamente a imagem',
	'blockedByDevice.headline': 'O SmartClaims não é compatível com navegadores de computador',
	'blockedByDevice.description':
		'O SmartClaims está a utilizar um navegador em um computador.<br/>A plataforma SmartClaims efectua a documentação de casos utilizando apenas dispositivos móveis.<br />Para continuar, acesse PolicyCheck em um dispositivo móvel',
	'fourAdditionalPictures.title': '',
	'button.ok': 'Avançar',
	'button.addLater': 'Adicionar mais tarde',

	'landing.headline': 'Bem-vindo à<br />Avaliação de Danos Auto',
	'landing.paragraph': 'A estimativa dos danos é realizada em<br />3 passos simples: ',
	'landing.stepDescription.fourDiagonalPerspectives': 'Carregue as fotos do veículo',
	'landing.stepDescription.damageImages': 'Carregue as fotos dos danos',
	'landing.stepDescription.damageDescription': 'Descreva brevemente o que aconteceu',
	'landing.additional-informations-section.text':
		'Com base nos dados fornecidos, os nossos especialistas farão a análise do sinistro reportado e dos danos do veículo.<br />Ao avançar, declaro que irei apresentar apenas os danos relativos a este sinistro.',
	'landing.termsAndConditionsLink':
		'Para avançar, deve ler e conhecer a Política de Privacidade da Allianz Portugal.',
	'button.start': 'Iniciar',

	'vehicleImages.overviewPhotos': 'Fotografias do veículo',
	'fourDiagonalPerspectives.vehicleFrontLeft.title':
		'Tire uma fotografia da diagonal frontal esquerda do veículo. A matrícula deve estar legível.',
	'fourDiagonalPerspectives.vehicleRearRight.title':
		'Tire uma fotografia da diagonal traseira direita do veículo. A matrícula deve estar legível.',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Foto exemplo da diagonal frontal esquerda',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Foto exemplo da diagonal traseira direita',
	'button.next': 'Avançar',

	'completeDamageImages.headline': 'Aviso',
	'damageImages.headline': 'Fotografias do dano',
	'damageImages.description':
		'Tire, pelo menos, 2 fotografias dos danos provocados pelo acidente de diferentes perspetivas (foto do plano geral com o dano / foto do dano isolado).',
	'damageImages.additionalImages': 'Fotografias adicionais',
	'damageImages.photo': 'Fotografias do dano',
	'completeDamageImages.description':
		'Tire, pelo menos, 2 fotografias dos danos provocados pelo acidente de diferentes perspetivas (foto do plano geral com o dano / foto do dano isolado).',

	'imageRecognitionFeedback2.exemplaryPhoto': 'FOTO EXEMPLIFICATIVA',
	'imageRecognitionMismatchModal.headline':
		'Vamos verificar se as fotografias carregadas são corretas',
	'button.backchangeImage': 'Tirar nova fotografia',
	'completeVehicleImagesModal.headline': 'Fotos pendentes',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Diagonal frontal esquerda',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Diagonal traseira direita',
	'vehicleImages.leftFrontOverview': 'Diagonal frontal esquerda',
	'vehicleImages.rightRearOverview': 'Diagonal traseira direita',
	'button.changeImage': 'Tirar nova fotografia',
	'button.deleteImage': 'Eliminar fotografia',
	'fourPerspectivesExampleModal.button.close': 'Ok',

	'completeDamageDescriptionModal.headline': 'Aviso',
	'completeDamageDescriptionModal.description':
		'Descreva resumidamente o acidente e os danos resultantes.',
	'damageDescription.headline.first': 'Descrição dos danos',
	'damageDescription.paragraph.first': 'Breve descrição dos danos no veículo',
	'damageDescription.placeholder':
		'Exemplo: O choque do outro carro danificou o meu para-choques dianteiro esquerdo e a ótica esquerda. O acidente ocorreu num cruzamento.',

	'review.headline.first': 'Resumo',
	'review.paragraph.first':
		'Antes de concluir, verifique que foram inseridos todos os dados necessários para a estimativa de reparação. <br /><br />A avaliação será submetida quando carregar em "Concluir".',
	'review.stepDescription.fourDiagonalPerspectives': 'Fotografias do veículo',
	'review.stepDescription.damageImages': 'Fotografias dos danos',
	'review.stepDescription.damageDescription': 'Descrição dos danos',
	'review.editViewButton': 'Ver/Alterar',
	'review.button.next': 'Concluir',

	'thankYou.headline': 'Obrigado por utilizar a Avaliação de Danos Auto!',
	'thankYou.paragraph.first': 'Confirmamos que a informação foi enviada corretamente.',
	'thankYou.paragraph.second':
		'Com base nas fotografias enviadas, iremos estimar o custo de reparação. Este processo demora até 4 horas.',
	'thankYou.paragraph.third': '(horas úteis de segunda a sexta-feira, das 9h às 18h).',
	'thankYou.paragraph.fourth': 'A estimativa será enviada para o seu e-mail ou telemóvel.',
	'thankYou.button.next': 'Avaliar a experiência',

	'feedback.button.send': 'Enviar',
	'feedback.rating': 'Como classifica a sua experiência com a Avaliação de Danos Auto?',
	'feedback.yourOpinion': 'Dê-nos a sua opinião (opcional)',
	'feedback.notSatisfied': 'nada satisfeito',
	'feedback.verySatisfied': 'muito satisfeito',

	'landingApproval.headline': 'Bem-vindo à<br />Avaliação de Danos Auto',
	'landingApproval.paragraph.first': 'Temos uma proposta para si!',
	'landingApproval.paragraph.second':
		'Analisámos a informação enviada e temos uma proposta para si.<br /><br />O valor proposto consiste no custo da reparação numa oficina da nossa rede convencionada pelo prazo de 3 meses.',
	'landingApproval.button.next': 'Avançar',

	'cashSettlementOffer.headline': 'Proposta Allianz Danos Auto',
	'cashSettlementOffer.description':
		'Com base na avaliação de danos, calculámos o custo de reparação do veículo:',
	'cashSettlementOffer.paragraph.first':
		'Atenção: o seu sinistro ainda se encontra sob análise, pelo que esta proposta poderá sofrer alterações.',
	'cashSettlementOffer.paragraph.second':
		'Caso a fatura da reparação, acrescida de IVA, exceda a nossa proposta, reembolsaremos o valor do IVA. Para isso, deverá enviar-nos a fatura para info@allianz.pt, colocando o nº do sinistro no assunto, no prazo de 2 meses após aceitação desta proposta.',
	'cashSettlementOffer.paragraph.third':
		'Após aceitação da proposta, o pagamento será enviado para a sua conta bancária no prazo de 3 dias úteis.',
	'cashSettlementOffer.table.title': 'Avaliação',
	'cashSettlementOffer.table.repairCost': 'Custo da reparação',
	'cashSettlementOffer.table.deductible': 'Dedução de Franquia',
	'cashSettlementOffer.table.sum': 'Total a receber',
	'cashSettlementOffer.table.vat': '(s/ IVA)',
	'cashSettlementOffer.accept': 'Validar dados',
	'cashSettlementOffer.reject': 'Rejeitar Proposta',

	'bankDetails.headline': 'Dados bancários',
	'bankDetails.paragraph.first':
		'Por favor, indique os seus dados bancários para transferência.<br />Certifique-se de que as informações estão corretas antes de confirmar.',
	'bankDetails.accountHolder.label': 'Nome Titular da Conta',
	'bankDetails.accountHolder.placeholder': 'José Silva',
	'bankDetails.accountHolder.error': '', //not displayed
	'bankDetails.tin.label': 'NIF',
	'bankDetails.tin.placeholder': '123456789',
	'bankDetails.tin.error': '', //not displayed

	'bankDetails.iban.label': 'IBAN',
	'bankDetails.iban.ibanChanged': 'Novo IBAN inserido. Por favor, anexe um comprovativo de IBAN.',
	'bankDetails.iban.invalidIban':
		'IBAN inválido. Por favor, verifique se o IBAN inserido está correto e anexe um comprovativo do mesmo.',
	'bankDetails.iban.notPortugueseError':
		'Formato de IBAN inválido. Por favor, verifique se o IBAN inserido está correto e anexe um comprovativo do mesmo.',
	'bankDetails.iban.emptyIban': 'Por favor, indique um IBAN válido.',
	'bankDetails.iban.placeholder': 'PT50 0010 0000 5555 7777 8888 1',

	'bankDetails.file.label': 'Comprovativo IBAN/NIB',
	'bankDetails.file.label.extensions': '(pdf ou jpeg file)',
	'bankDetails.file.placeholder': 'BankAccount.pdf',
	'bankDetails.accept': 'Aceitar Proposta',
	'bankDetails.reject': 'Rejeitar Proposta',

	'bankDetails.modal.headline': 'Aviso',
	'bankDetails.modal.description': 'Por favor, certifique-se que:',
	'bankDetails.modal.notUploaded': 'Anexou um comprovativo de IBAN.',
	'bankDetails.modal.invalidIban': 'O IBAN se encontra válido.',
	'bankDetails.modal.notPortugueseError':
		'O IBAN foi indicado corretamente (apenas aceitamos IBAN português).',
	'bankDetails.modal.wrongFile': 'Ficheiro inválido. Tente novamente ou anexe outro ficheiro.',

	'waitForAudit.thankYou': 'Obrigado pela sua opinião!',

	'nooffer.paragraph.first':
		'Lamentamos, mas não foi possível avaliar os danos com os dados que submeteu.',
	'nooffer.paragraph.second':
		'Brevemente entraremos em contacto consigo para agendar uma peritagem presencial.',
	'button.finish': 'Concluir',

	'offerAccepted.headline': 'Recebemos a sua resposta.',
	'offerAccepted.rating': 'Como classifica a nossa proposta?',

	'offerRejected.headline': 'Lamentamos que não tenha aceite a nossa proposta.',
	'offerRejected.description':
		'Brevemente entraremos em contacto consigo para agendar uma peritagem presencial.',
	'offerRejected.rating': 'Como classifica a nossa proposta?',

	'impactDirections.title':
		'A nossa proposta refere-se aos danos apresentados no diagrama abaixo, decorrentes do sinistro',
	'impactDirections.button.next': 'Ver proposta',

	'timeout.headline.first':
		'Lamentamos,<br />mas o link para a plataforma de Avaliação de Danos Auto já não se encontra válido.',
	'timeout.paragraph.first':
		'Enviámos uma comunicação (SMS ou email) com o próximo passo. Para qualquer esclarecimento, contacte o <u>apoio ao cliente.</u>',

	'thanks.headline.first': 'Obrigado por utilizar a Avaliação de Danos Auto!',

	'invalidFile.size.title': 'Tamanho de imagem inválido',
	'invalidFile.size.description': 'Tamanho da imagem maior que o máximo exigido.',
	'invalidFile.extension.title': 'Tipo de ficheiro não suportado',
	'invalidFile.extension.description':
		'Tipo de ficheiro não suportado. Tipos de ficheiro suportados: .jpg, .heic, .heif, .jpeg e .png',
};

export default messages;
